import { Link } from 'react-router-dom';
import facebookIcon from '@assets/icons/icon-facebook.svg';
import instagramIcon from '@assets/icons/icon-instagram.svg';



const SideElement = (): JSX.Element => {

	return (
		<div className='app-side-element'>

			<Link to={'https://www.facebook.com/vetlimce'} className='disable-selection'>
				<img src={facebookIcon} alt='social-media-facebook' />
			</Link>

			<Link to={'https://www.instagram.com/vetlimce'} className='disable-selection'>
				<img src={instagramIcon} alt='social-media-instagram' />
			</Link>

		</div>
	);
};

export default SideElement;